export default __webpack_public_path__ + "static/media/Suv.85435c95.svg";